import { render, staticRenderFns } from "./Monopolis.vue?vue&type=template&id=1dd8671e&scoped=true&"
import script from "./Monopolis.vue?vue&type=script&lang=js&"
export * from "./Monopolis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8671e",
  null
  
)

export default component.exports